<template>
  <div class="back" ref="homePage">
    <!-- <div class="imageDiv" >
      应急融合通信指挥系统
    </div>-->

    <!-- 登陆dia -->
    <!--    <div class="dialog" v-if="isLogin == false">-->
    <!--      <div class="loginDiv">-->
    <!--        <el-input placeholder="请输入姓名" v-model="userName" class="phoneNum"></el-input>-->
    <!--        <el-input placeholder="请输入手机号" v-model="phoneNumber" class="phoneNum" type="number">-->
    <!--          <el-button-->
    <!--            slot="append"-->
    <!--            @click="getVcode"-->
    <!--            style="font-size:14px;padding-left:5px;padding-right:5px"-->
    <!--          >{{getVcodeMsg}}</el-button>-->
    <!--        </el-input>-->
    <!--        <el-tag type="danger" class="tag" v-if="errPhone">！请输入正确的电话号码</el-tag>-->
    <!--        <el-input placeholder="请输入验证码" v-model="vCode" type="number" class="phoneNum"></el-input>-->
    <!--        <div class="subBtn" @click="subForm">提交</div>-->
    <!--        <el-tag type="danger" class="tag" v-if="errFrom">{{tagMsg}}</el-tag>-->
    <!--      </div>-->
    <!--    </div>-->
    <div>
      <div class="imageDiv">
        <img src="../../assets/images/yingji.png" class="index_btn_video2" alt/>
      </div>
      <div class="imageDiv2" @click="toPhoneVideo(1)">
        <img src="../../assets/images/index_video.jpg" class="index_btn_video" alt/>
      </div>
      <div class="imageDiv2" @click="toPhoneVideo(2)">
        <img src="../../assets/images/index_video2.jpg" class="index_btn_video" alt/>
      </div>
      <div class="imageDiv2" @click="toPhoneVideo(3)">
        <img src="../../assets/images/index_video3.jpg" class="index_btn_video" alt/>
      </div>
      <div class="imageDiv2">
        <img src="../../assets/images/padImage/zonghe.png" class="index_btn_video2" alt/>
      </div>
      <div class="imageDiv3">
        <img src="../../assets/images/keyerLogo.png" class="index_btn_video3" alt/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  created() {
    this.isLoginFunc()
  },
  data() {
    return {
      clientHeight: "",
      dialogFormVisible: true,
      // 是否登陆
      isLogin: false,
      userName: "",
      phoneNumber: "",
      timer: false,
      getVcodeMsg: "获取验证码",
      timeCount: 60,
      vCode: "",
      errPhone: false,
      errFrom: false,
      tagMsg: ""
    };
  },
  mounted() {
    // 获取浏览器可视区域高度
    this.clientHeight = `${document.documentElement.clientHeight}`; //document.body.clientWidth;
    //console.log(self.clientHeight);
    window.onresize = function temp() {
      this.clientHeight = `${document.documentElement.clientHeight}`;
    };
  },
  watch: {
    // 如果 `clientHeight` 发生改变，这个函数就会运行
    clientHeight: function () {
      this.changeFixed(this.clientHeight);
    }
  },
  methods: {
    // 获取缓存登陆办法
    isLoginFunc() {
      var isLoginStaticCount = localStorage.getItem('isLoginStatic')
      if (isLoginStaticCount == 1) {
        this.isLogin = true;
      }
    },
    subForm() {
      var reg = /^1[3456789]\d{9}$/;
      if (this.userName == "") {
        this.errFrom = true;
        this.tagMsg = "姓名不可为空";
      } else if (this.phoneNumber == "" || !reg.test(this.phoneNumber)) {
        this.errFrom = true;
        this.tagMsg = "手机号格式有误";
      } else if (this.vCode == "") {
        this.errFrom = true;
        this.tagMsg = "验证码不可为空";
      } else {
        this.errFrom = false;
        this.$axios({
          url: this.$apiUrl + "/app/api/receive/login",
          method: "post",
          data: {realname: this.userName, mobile: this.phoneNumber, smsCode: this.vCode}
        })
          .then(response => {
            console.log(response);
            if (response.data.code == 200) {
              this.isLogin = true;
              localStorage.setItem('isLoginStatic', 1)
              // 缓存登陆状态
            } else {
              this.$message({
                message: response.data.msg,
                type: "warning"
              });
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    getVcode() {
      if (this.getVcodeMsg == "获取验证码") {
        console.log("getCOde");
        var reg = /^1[3456789]\d{9}$/;
        if (!reg.test(this.phoneNumber)) {
          console.log("err");
          this.errPhone = true;
        } else {
          this.$axios
            .get(this.$apiUrl + "/app/api/receive/sms", {
              params: {
                mobile: this.phoneNumber
              }
            })
            .then(function (res) {
              console.log(res);
            })
            .catch(function (err) {
              console.log(err);
            });
          this.errPhone = false;
          this.timer = false;
          setInterval(() => {
            if (this.timeCount >= 1 && this.timer == false) {
              this.timeCount--;
              this.getVcodeMsg = "请在" + this.timeCount + "秒后重试";
            } else {
              this.timeCount = 60;
              this.getVcodeMsg = "获取验证码";
              this.timer = true;
            }
          }, 1000);
        }
      }
    },
    toPhoneVideo(i) {
      console.log(i);
      if (i == 1) {
        this.$router.push({path: "/phone_viode"});
      } else if (i == 2) {
        this.$router.push({path: "/phone_ppt"});
      } else if (i == 3) {
        this.$router.push({path: "/phone_word"});
      }
    },
    changeFixed(clientHeight) {
      //动态修改样式
      console.log(clientHeight);
      // this.$refs.homePage.style.height = clientHeight + "px";
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  margin: 0;
  padding: 0;
}

.back {
  width: 100%;
  background-image: url("../../assets/images/padImage/kllback.png");
  background-size: 100% 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
}

.imageDiv {
  width: 300px;
  height: 10px;
  margin: 0 auto;
  margin-bottom: 30px;
  padding-top: 30px;
  text-align: center;
  color: #fff;
  font-size: 28px;
  font-weight: bolder;
}

.imageDiv2 {
  width: 300px;
  /* height: 130px; */
  margin: 0 auto;
  margin-top: 10px;
}

.imageDiv3 {
  width: 100%;
  /* height: 130px; */
  margin: 0 auto;
  margin-top: 40px;
}

.index_btn_video {
  width: 100%;
  height: 130px;
}

.index_btn_video2 {
  width: 100%;
  height: 25px;
}

.index_btn_video3 {
  width: 100%;
  height: 30px;
}

.dialog {
  width: 100%;
  background-color: rgba(00, 00, 00, 0.5);
  height: 2000px;
  position: fixed;
  top: 0;
}

.loginDiv {
  width: 80%;
  margin: 0 auto;
  margin-top: 25%;
  background: #fff;
  border-radius: 5px;
  padding-bottom: 30px;
}

.phoneNum {
  width: 90%;
  margin-left: 5%;
  margin-top: 30px;
}

.subBtn {
  width: 90%;
  margin: 0 auto;
  margin-top: 20px;
  height: 40px;
  text-align: center;
  background: cornflowerblue;
  line-height: 40px;
  color: #fff;
  border-radius: 3px;
}

.tag {
  width: 90%;
  margin-left: 5%;
  padding-left: 5%;
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/phone/phone_index.vue